import { render, staticRenderFns } from "./VersionUpdater.vue?vue&type=template&id=5f809e00&"
import script from "./VersionUpdater.vue?vue&type=script&lang=js&"
export * from "./VersionUpdater.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports